import { Api } from "./api"

const PATH = 'condition-generale'
const ENDPOINTS = {
    Liste:'liste',
    Store:'store',
    Show:'show',
    Update:'update',
    Publish:'publish',
    Unpublish:'unpublish',
    Archive:'archive',
    Delete:'delete'
}

const getDocuments = (params={},signal) => {
    const query = new URLSearchParams(params).toString()
    return Api.get(`${PATH}/${ENDPOINTS.Liste}${query ? `?${query}` : ''}`, signal)
}

const getDocumentDetails = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Show}/${id}`, signal)
}

const storeDocument = (payload,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Store}`,payload, signal)
}

const updateDocument = (id,payload,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Update}/${id}`,payload, signal)
}

const publishDocument = (id,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Publish}/${id}`,'', signal)
}

const unpublishDocument = (id,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Unpublish}/${id}`,'', signal)
}

const archiveDocument = (id,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Archive}/${id}`,'', signal)
}

const deleteDocument = (id,signal) => {
    return Api.erase(`${PATH}/${ENDPOINTS.Delete}/${id}`, signal)
}

export const ConditionGeneraleApi={
    getDocuments,
    getDocumentDetails,
    storeDocument,
    updateDocument,
    publishDocument,
    unpublishDocument,
    archiveDocument,
    deleteDocument
}
